import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardFooter,
  MDBBtn,
} from "mdb-react-ui-kit";
import whiteLogo from "../../img/images/logo_white.png";
import { Box, CircularProgress, Snackbar, Alert } from "@mui/material";
import styles from "./AcceptInvite.module.css";
const REACT_APP_SERVER_URL = process.env.REACT_APP_SERVER_URL;

const AcceptInvite = () => {
  const navigate = useNavigate();
  const token = window.location.pathname.split("/")[2];
  console.log("token", token);
  const [firstName, setFirstName] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [workspaceName, setWorkspaceName] = useState("");
  const [role, setRole] = useState("");
  const [loader, setLoader] = useState(false);
  const [acceptButtonLoader, setAcceptButtonLoader] = useState(false);
  const [declineButtonLoader, setDeclineButtonLoader] = useState(false);
  const [buttonProcessing, setButtonProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  React.useEffect(() => {
    setLoader(true);
    fetch(`${REACT_APP_SERVER_URL}/user_exists`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ token: token }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then((data) => {
        if (data.user_exist === false) {
          navigate("/registerInvite", { state: { token } });
        } else if (data.user_exist === true) {
          setFirstName(data.name);
          setOwnerEmail(data.sender_email);
          setWorkspaceName(data.workspace_name);
          setRole(data.role);
          setLoader(false);
        }
        if (data.valid === false) {
          navigate("/", {
            state: { error: true, msg: "Accept link expired or wrong" },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [navigate, token]);

  const handleAccept = () => {
    setButtonProcessing(true);
    setAcceptButtonLoader(true);
    fetch(`${REACT_APP_SERVER_URL}/accept_invite`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ token: token }),
    })
      .then((response) => {
        if (response.status === 200) {
          setAcceptButtonLoader(false);
          // Land the invitee on the first section they're allowed into
          // (admin → /myapps; member → first allowed section). The cookie
          // is already set server-side, so the next render reads profile
          // and routes correctly.
          navigate("/dashboard/myapps");
        } else {
          setErrorMessage("Invalid Invite");
          setErrorSnackbarOpen(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDecline = () => {
    setButtonProcessing(true);
    setDeclineButtonLoader(true);
    fetch(`${REACT_APP_SERVER_URL}/reject_invite`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ token: token }),
    })
      .then((response) => {
        if (response.status === 200) {
          setDeclineButtonLoader(false);
          navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {loader && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            height: "100vh",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loader && (
        <div className={styles.container}>
          <img
            src={whiteLogo}
            alt="Easexpense white logo"
            className={styles.logo}
          />
          <MDBCard alignment="center" className={styles.card}>
            <MDBCardBody>
              <MDBCardTitle className={styles.cardTitle}>
                Hello {firstName}👋
              </MDBCardTitle>
              <MDBCardText className={styles.cardText}>
                <p className={styles.text}>
                  <span className={styles.bold}>{ownerEmail}</span> has invited
                  you to join{" "}
                  <span className={styles.bold}>"{workspaceName}"</span>.
                </p>
                <br />
                <span className={styles.infoText}>
                  This workspace will allow you to collaborate on exciting
                  projects and stay updated with the latest developments.
                </span>
                <br />
                <h4 className={styles.role}>Role: {role}</h4>
              </MDBCardText>
            </MDBCardBody>
            <MDBCardFooter className={styles.cardFooter}>
              <MDBBtn
                disabled={buttonProcessing}
                onClick={handleAccept}
                className={styles.acceptButton}
              >
                {!acceptButtonLoader ? (
                  "Accept"
                ) : (
                  <CircularProgress size={26} className={styles.buttonLoader} />
                )}
              </MDBBtn>
              <MDBBtn
                disabled={buttonProcessing}
                onClick={handleDecline}
                className={styles.rejectButton}
              >
                {!declineButtonLoader ? (
                  "Reject"
                ) : (
                  <CircularProgress size={26} className={styles.buttonLoader} />
                )}
              </MDBBtn>
            </MDBCardFooter>
          </MDBCard>
        </div>
      )}
      <Snackbar
        open={errorSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleErrorSnackbarClose}
      >
        <Alert
          onClose={handleErrorSnackbarClose}
          variant="filled"
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AcceptInvite;
